import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendImageStyle, BackendMutationDeleteImageStyleArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteImageStyle($id: ID!) {
    deleteImageStyle(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteImageStyleArgs;
type Result = Pick<BackendImageStyle, 'id'>;

export const deleteImageStyle = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
